import React from 'react';
import { Container, Typography, Link, Card } from '@sm/wds-react';
import { HomeBottomCardSkeletonLoader } from './HomeBottomCardSkeleton';
import './home-bottom-card.scss';

export type HomeBottomCardProps = {
  headline: string;
  message: string;
  image: () => React.ReactElement;
  ctaText: string;
  ctaLink: string;
  ctaNewTab?: boolean;
  loading?: boolean;
};

export const HomeBottomCard: React.FC<HomeBottomCardProps> = ({
  headline,
  message,
  image,
  ctaText,
  ctaLink,
  ctaNewTab,
  loading,
}) => {
  const templateClass = 'sm-home-bottom-card';
  const ImageComponent = image;

  return (
    <Choose>
      <When condition={!!loading}>
        <HomeBottomCardSkeletonLoader />
      </When>
      <Otherwise>
        <Card className={templateClass}>
          <Container
            flex
            flexJustify="center"
            className={`${templateClass}__container`}
          >
            <Container className={`${templateClass}__img-container`} mt={1}>
              <ImageComponent />
            </Container>
            <Container flex flexDirection="column" flexJustify="between" ml={4}>
              <Typography
                className={`${templateClass}__headline`}
                component="section"
                variant="sectionTitle"
              >
                {headline}
              </Typography>
              <Typography
                className={`${templateClass}__message wds-m-t-2`}
                component="div"
                variant="bodySm"
              >
                {message}{' '}
                <Link
                  data-testid="cta"
                  href={ctaLink}
                  target={ctaNewTab ? '_blank' : undefined}
                  rel={ctaNewTab ? 'noreferrer noopener' : undefined}
                >
                  <strong>{ctaText}</strong>
                </Link>
              </Typography>
            </Container>
          </Container>
        </Card>
      </Otherwise>
    </Choose>
  );
};

HomeBottomCard.defaultProps = {
  loading: false,
  ctaNewTab: false,
};

export default HomeBottomCard;
